// 9fbef606107a605d69c0edbcd8029e5d
const FILTER_CONFIG = {
  facetType: {
    sort: 'radioType',
    availability: 'radioType_availability',
    color: 'colorType',
    checkBox: 'checkBoxType',
    size: 'sizeType',
    customerRating: 'customerRating',
  },
  facetId: {
    sort: '1', // sudo id for ordering to 1st position in Object.Entries in Filter.native constructor
    availability: '2',
    color: 'TCPColor_uFilter',
    groupedSize: 'v_tcp_groupedsize_uFilter',
    size: 'v_tcpsize_uFilter',
    customerRating: 'TCPBazaarVoiceRating_inText_uFilter',
  },
  mapping: {
    color: 'TCPColor_uFilter',
    size: 'v_clothingsize_uFilter',
    fit: 'v_tcpfit_unbxd_uFilter',
    gender: 'gender_uFilter',
    min_offer_price: 'unbxd_price_range_uFilter',
  },
  fitList: ['husky', 'slim', 'plus', 'regular'],
  MIN_OFFER_PRICE: 'min_offer_price',
  facetFilter: {
    size: 'v_clothingsizefacet_uFilter'
  }
};

export default FILTER_CONFIG;
